import React from "react";
import { Link } from "react-router-dom";
import {
  ShieldCheck, Award, UserCheck, Home as HomeIcon, MapPin, Globe2,
  ArrowRight,
} from "lucide-react";

const SIGNALS = [
  { Icon: ShieldCheck, label: "Registered NDIS provider" },
  { Icon: Award, label: "Practice Standards aligned" },
  { Icon: UserCheck, label: "Worker-screened support staff" },
  { Icon: HomeIcon, label: "SIL · SDA · Nursing · Coordination" },
  { Icon: MapPin, label: "Melbourne & Perth hubs" },
  { Icon: Globe2, label: "National intake" },
];

// Premium trust bar that overlaps the hero / next section. Renders as a
// floating gradient card with two accent CTAs.
export default function TrustStrip() {
  return (
    <section className="relative z-30" data-testid="trust-strip">
      {/* Pull up over the hero's bottom curve */}
      <div className="alpha-container -mt-12 md:-mt-16 relative">
        <div
          className="relative rounded-2xl md:rounded-[20px] overflow-hidden border border-white/10 shadow-2xl"
          style={{
            background:
              "linear-gradient(95deg, #1B0B3D 0%, #2B1659 35%, #3E2478 70%, #4FA56E 140%)",
          }}
        >
          {/* Subtle inner glow */}
          <div className="absolute -right-20 -top-20 w-72 h-72 rounded-full pointer-events-none alpha-glow-b"
            style={{ background: "radial-gradient(closest-side, rgba(79,165,110,0.45), transparent 70%)", filter: "blur(40px)" }} aria-hidden />
          <div className="alpha-grain-dark" aria-hidden />

          <div className="relative grid lg:grid-cols-12 gap-4 px-5 py-5 md:px-7 md:py-6 items-center">
            <ul className="lg:col-span-9 grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-2.5 text-white">
              {SIGNALS.map((s) => (
                <li key={s.label} className="flex items-center gap-2 min-w-0">
                  <span className="w-7 h-7 rounded-lg bg-white/10 backdrop-blur flex items-center justify-center shrink-0">
                    <s.Icon className="w-3.5 h-3.5 text-[color:var(--alpha-green-500)]" />
                  </span>
                  <span className="text-[12px] md:text-[13px] font-semibold truncate">{s.label}</span>
                </li>
              ))}
            </ul>

            <div className="lg:col-span-3 flex flex-col sm:flex-row lg:flex-col gap-2">
              <Link
                to="/referrals"
                className="bg-white text-[color:var(--alpha-purple-700)] rounded-full px-4 py-2.5 text-sm font-semibold inline-flex items-center justify-center gap-2 hover:scale-[1.02] transition-transform"
                data-testid="trust-strip-refer"
              >
                Make a Referral <ArrowRight className="w-4 h-4" />
              </Link>
              <Link
                to="/our-homes"
                className="border border-white/35 text-white rounded-full px-4 py-2.5 text-sm font-semibold inline-flex items-center justify-center gap-2 hover:bg-white/10 transition-colors"
                data-testid="trust-strip-homes"
              >
                View Homes <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
